import {
  Modal,
  Paper,
  useMediaQuery,
  useTheme,
  IconButton,
  Box,
  SxProps,
} from '@mui/material';
import { CircleCloseIcon } from 'Components/CircleCloseIcon';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface ICustomDialog {
  showDialog: boolean;
  onclose: () => void;
  children: React.ReactNode;
  width?: string | Record<string, string | number>;
  height?: string | Record<string, string | number>;
  mt?: string;
  isScroll?: boolean;
  top?: string;
  removeZx?: boolean;
  paperSx?: SxProps;
  forceHighZIndex?: boolean;
  zIndex?: number;
}
export const CustomDialog = ({
  onclose,
  showDialog,
  children,
  width,
  height,
  mt,
  isScroll,
  top,
  removeZx = false,
  paperSx,
  forceHighZIndex = false,
  zIndex,
}: ICustomDialog) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const getZIndex = () => {
    if (zIndex != null) return zIndex;
    if (forceHighZIndex) return 10001;
    if (isDesktop && !removeZx) return 9999;
    return undefined;
  };
  return (
    <Modal
      open={showDialog}
      onClose={onclose}
      sx={{
        overflowY: isScroll ? 'auto' : undefined,
        zIndex: getZIndex(),
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(8, 30, 84, .8)',
            height: '100vh',
          },
        },
      }}
    >
      <>
        <Paper
          sx={{
            position: 'absolute',
            top: top || '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: width || { xs: '350px', sm: '770px' },
            height: height || { xs: '350px', sm: '486px' },
            backgroundColor: 'primary.shade_100',
            borderRadius: '16px',
            mt: mt,
            ...paperSx,
          }}
        >
          <IconButton
            onClick={onclose}
            sx={{
              position: 'absolute',
              top: isDesktop ? '24px' : '15px',
              left: isDesktop ? '19px' : '15px',
              p: 0,
            }}
          >
            <CircleCloseIcon
              alt={
                Dictionary[DICTIONARY.Requests].deleteFile.deleteModalExitAlt
              }
            />
          </IconButton>
          {children}
        </Paper>
        {isScroll && (
          <Box
            sx={{
              height: '160vh',
              width: '200px',
            }}
          />
        )}
      </>
    </Modal>
  );
};
